module.exports = __webpack_public_path__ + "imgcvh/hero-5.e06b64d1.jpg";